<template>
    <div class="terms-wrapper">
        <app-header-mini :img="'/static/img/terms/header.jpg'"></app-header-mini>
        <div class="terms-content">
            <h1 class="indent">Terms and conditions of use</h1>
            <p class="indent">This website is the property of <span class="strong">ALCOMET AD</span>. Entering the website of <span class="strong">ALCOMET AD</span>, you accept the Terms and Conditions of Use.</p>
            <p class="indent">You may use the website information to facilitate your business and commercial relations with <span class="strong">ALCOMET AD</span> only.</p>
            <p class="indent">You may not change copy, publish and/or disseminate any part of this website contents or otherwise violate the copyrights on the text materials, data, photos and any other information published at this website.</p>
            <p class="indent"><span class="strong">ALCOMET AD</span> reserves the right to edit the contents of this website and suspend the access to it at any time without prior notice to the website users. The purpose of this website and its contents is to ensure your convenience.  <span class="strong">ALCOMET AD</span> does not guarantee that the website is free of errors and that the access to the website is uninterruptable. We do not bear responsibility for any loss of information due to website reloading or copying of materials, images, texts or other information included in its contents.</p>
            <p class="indent">All published trademarks, logo and key elements of the corporate identity of<span class="strong"> ALCOMET AD</span> are registered as service marks and protected under the laws of the Republic of Bulgaria and the international standards.</p>
            <p class="indent">All materials contained in this website are protected under the Law on Copyright.</p>
            <p class="indent">Requests and offers sent to the Company via this website have the nature of preliminary inquiries for obtaining information. For particular requests and engagements, please contact the specified competent persons.</p>
            <p class="indent">In the course of carrying out its business, <span class="strong">ALCOMET AD</span> complies with the provisions of the Law on Public Offering of Securities and the Regulation on its implementation, the Law on Commerce, the Law on Accountancy, the Law on Copyright, the Law on Independent Financial Audit, the Law on Internal Audit in the Public Section, the Law  on Market Abuse with Financial Instruments, the National  and International Financial Reporting Standards, the International Principles of Good Corporate Governance, the Labour Code, the National Corporate Governance Code, etc.</p>
        </div>
    </div>
</template>

<script>
import HeaderMini from "./shared/HeaderMini";
export default {
  components: {
    appHeaderMini: HeaderMini
  }
};
</script>

<style scoped>
.terms-content {
  padding: 0 0 60px;
}
.terms-content > h1 {
  font-size: 34px;
  font-weight: 500;
  margin: 0 auto 25px;
  width: 800px;
}
.terms-content > p {
  font-size: 19px;
  text-align: justify;
  line-height: 32px;
  margin: 15px auto;
  width: 800px;
}
@media screen and (max-width: 1000px) {
  .terms-content > h1 {
    font-size: 20px;
    padding: 0 30px;
    width: 100%;
  }
  .terms-content > p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Terms.vue